import {
  FulfillmentTypeAssignRequestType,
  FulfillmentTypeAssignResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useFulfillmentTypeAssign = (fulfillmentTypeId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: FulfillmentTypeAssignRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `fulfillment-type/${fulfillmentTypeId}/assign`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as FulfillmentTypeAssignResponseType,
      ),

    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentType],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.FulfillmentTypeStats],
      });
    },
  });
};
